const MODELS = {
  ghg_15: { m: -0.31, c: 2.7 },
  ghg_30: { m: -0.48, c: 2.84 },
  co2_15: { m: -0.31, c: 2.62 },
  co2_30: { m: 0.44, c: 2.72 },
  ghg_gdp_15: { m: -0.53, c: 4.11 },
  ghg_gdp_30: { m: -1.1, c: 4.93 },
  co2_mwh_15: { m: -0.33, c: 3.33 },
  co2_mwh_30: { m: -0.78, c: 3.9 },
  co2_pe_15: { m: -0.51, c: 3.0 },
  co2_pe_30: { m: 0.66, c: 3.21 },
};

export const getAnnualReductionValue = (temperature, modelKey) => {
  const model = MODELS[modelKey];
  if (!model) return "";
  const { m, c } = model;
  return (Number(temperature) - c) / m;
};

export const calculateTargetReduction = (
  isSbt,
  targetYear,
  baseYear,
  sbtiTemperature,
  regressionModel,
  targetReduction,
) => {
  const isSbtiEnabled = String(isSbt || "").toLowerCase() === "yes";
  if (!isSbtiEnabled) return targetReduction;
  const span = Number(targetYear) - Number(baseYear);
  if (!Number.isFinite(span)) return "";
  const annual = getAnnualReductionValue(sbtiTemperature, regressionModel);
  if (!Number.isFinite(annual)) return "";
  return span * annual;
};
